import { RESET } from '../actionTypes';
import { projectsActions } from '../reducer';

export default () => projectsActions[RESET]();
